export default __webpack_public_path__ + "static/CNTransfer-e1acd18822eb9619af1a6ba63e3df1c3.png";